import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './modules/user'
import authStore from './modules/auth'
import profileStore from './modules/profile'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
   user: userStore,
   auth: authStore,
   profile: profileStore

  }
})
